<template>
  <div class="language-selector">
    <div class="language-options">
      <div
          v-for="lang in languages"
          :key="lang.code"
          class="language-card"
          :class="{ active: lang.code === selectedLang }"
          @click="selectLanguage(lang.code)"
      >
        <!-- Utilizziamo flag-icons tramite le classi CSS -->
        <span :class="['fi', 'fi-' + lang.flag]" class="flag-icon"></span>
        <span class="language-label">{{ lang.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",
  props: {
    /**
     * Supporta il binding con v-model.
     * Se il genitore non passa un valore, verrà usata la lingua del browser (se disponibile tra le opzioni)
     */
    value: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      // Definizione delle lingue: codice ISO, label (in lingua nativa) e codice per flag‑icons
      languages: [
        { code: "fr", label: "Français", flag: "fr" },
        { code: "nl", label: "Nederlands", flag: "nl" },
        { code: "en", label: "English", flag: "gb" }, // per l'inglese usiamo "gb" (bandiera britannica)
        { code: "it", label: "Italiano", flag: "it" },
        { code: "de", label: "Deutsch", flag: "de" }
      ],
      selectedLang: this.value
    };
  },
  created() {
    // Estrae i primi due caratteri della lingua del browser in minuscolo
    const browserLang =
        (navigator.language || navigator.userLanguage).substr(0, 2).toLowerCase();

    // Verifica se il browserLang è tra quelli disponibili
    const availableCodes = this.languages.map((lang) => lang.code);
    const initialLang = availableCodes.includes(browserLang)
        ? browserLang
        : this.value;

    if (initialLang !== this.selectedLang) {
      this.selectedLang = initialLang;
      // Emette l'evento per il v-model (cioè l'evento "input")
      this.$emit("input", initialLang);
    }
  },
  methods: {
    selectLanguage(code) {
      this.selectedLang = code;
      // Supporta il binding con v-model emettendo l'evento "input"
      this.$emit("input", code);
    }
  },
  watch: {
    // Se il valore del v-model cambia dall'esterno, aggiorna la selezione interna
    value(newVal) {
      this.selectedLang = newVal;
    }
  }
};
</script>

<style scoped>
/* Importa il CSS di flag-icons (assicurati che il percorso sia corretto nel tuo progetto) */
@import "~flag-icons/css/flag-icons.min.css";

* {
  box-sizing: border-box;
}

.language-selector {
  width: 100%;
  padding: 10px 0;
  background: #fff;
  overflow-x: hidden;
}

.language-options {
  display: flex;
  flex-wrap: nowrap; /* Tutte le card sulla stessa riga */
  justify-content: space-between;
  align-items: center;
}

.language-card {
  /* Distribuzione equa: ogni card occupa in modo equo lo spazio disponibile */
  flex: 1 1 auto;
  max-width: calc(100% / 5);
  margin: 0 4px;
  padding: 8px;
  border: 2px solid #a82c35;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  min-width: 0;
}

.language-card:hover {
  border-color: #008233;
}

.language-card.active {
  border-color: #008233;
  background: #f0f0f0;
}

.flag-icon {
  font-size: 1.8em;
  margin-bottom: 4px;
}

.language-label {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Riduce leggermente le dimensioni su schermi piccoli */
@media (max-width: 480px) {
  .flag-icon {
    font-size: 1.4em;
  }
  .language-label {
    font-size: 12px;
  }
}

/* Sotto i 430px nasconde il testo per evitare overflow */
@media (max-width: 430px) {
  .language-label {
    display: none;
  }
}
</style>
